import httpClient from "@plugins/http";
import { ApiResponse } from "@apis/api.ts";

interface TokenResponse {
  token: string;
}

const fetchHtmlToken = async (): Promise<ApiResponse<TokenResponse>> => {
  return httpClient.get("/apis/html5/token");
};

export default {
  fetchHtmlToken,
};
